import {AccessDeniedError} from '@hm/fundamental'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import {ROUTES} from './routing/routes'

/** Shown when the URL points to a hierarchy node (location / plant) the user has no access to */
export const AccessDeniedPage: React.FC = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const navigateToStartPage = useCallback(() => navigate(ROUTES.path, {replace: true}), [navigate])

  return (
    <div className="flex flex-col">
      <AccessDeniedError
        title={t('suite.accessDeniedPage.title')}
        description={t('suite.accessDeniedPage.description')}
        data-cy="access_denied_error"
        // the design-system page only offers a single action; send the user back to a valid start
        logoutText={t('suite.notFoundPage.openStartPage')}
        onLogout={navigateToStartPage}
      />
    </div>
  )
}
